module.exports = __webpack_public_path__ + "app/brand/brand-personalise-portal-2Zhyy8ew.html";